// components/modals/SaveSearchModal.js
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch } from "react-redux";
import { updateMyListData } from "../../redux/action";

const EditMyListModal = ({ show, onHide, selectedSearch, fetchMyListData, role, signInID, sbnID }) => {

    const dispatch = useDispatch();
    const [listName, setListName] = useState("");

    useEffect(() => {
        if (selectedSearch) {
            setListName(selectedSearch.list_name || "");
        }
    }, [selectedSearch]);

    const handleEditMyList = () => {
        const requestPayload = {
            old_list_name: selectedSearch.list_name,
            list_name: listName,
            sbn_id: sbnID,
            user_id: parseInt(signInID),
            role: role
        }

        const requestOption = {
            method: "PUT",
            mode: "cors",
            headers: HeaderAuthentication.updateAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };
        // console.log(requestPayload, 'requestPayload')
        dispatch(updateMyListData(requestOption, fetchMyListData, onHide));
    };

    return (
        <Modal show={show} onHide={onHide} centered className="saved-search-modal">
            <Modal.Header closeButton>
                <Modal.Title>Update List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="searchName">
                    <Form.Label>List Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter list name"
                        value={listName}
                        onChange={(e) => setListName(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleEditMyList}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditMyListModal;
